import {getPrivateAxios, StepPayload, StepTypeRect} from '@blesk-frontend/api';

export interface UploadScreenshotParams {
  rects: StepTypeRect[];
  filename: string[];
  prefix: string;
  onProgress?: (progress: number) => void;
}

export const fetchUploadScreenshot = async (file: Blob, params: UploadScreenshotParams) => {
  const {data} = await getPrivateAxios().post<StepPayload['src']>(
    '/files/upload-screenshot',
    {file, ...params},
    {
      headers: {'Content-Type': 'multipart/form-data'},
      onUploadProgress: (progressEvent) => {
        if (params?.onProgress) {
          const percent = progressEvent.total
            ? Math.max(Math.round((progressEvent.loaded * 100) / progressEvent.total) - 5, 0)
            : 0;
          params.onProgress(percent);
        }
      },
    },
  );

  return data;
};
